
$(document).on('click', '.collapsible-trigger', function(e) {
  e.preventDefault();
  $(this).toggleClass("is-open");
  $(this).parent().find(".collapsible-content").toggleClass("is-open");
});

/* Product Description Tabs */
$(document).ready(function() {
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      e.preventDefault();
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
});

/* Collection Filter */
(function($) {
// On Document ready
  $(document).ready(function() {
    $(document).on('click', '.filter-tag-list .tag-list', function(e) {
      e.preventDefault();
      var $item = $(e.currentTarget);
      $item.toggleClass('active');
$item.closest('.collection-sidebar').find('.filter-tag-list').each(function(i, taglist) {
        var $taglist = $(taglist);
        
        var selectedTags = [];
        $taglist.find('a.active').each(function(i, item) {
          var tag = $(item).data('tag');
          var notInList = selectedTags.indexOf(tag) == -1;
          if (notInList) {
            selectedTags.push(tag);
          }
        });
        
        
        if (selectedTags.length) {
          var collection_handle = $('.collection_handle').val();
          var  newURL =  '/collections/' + collection_handle + '/' + selectedTags.join('+');

          $.ajax({
            url: newURL,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){

              $('.filter--clear').show();
              
              var $products = $(responseHTML).find('#product-grid li');
        
              
              
              var $productsList = $('#product-grid');
              var $filterCount = $('.filters-toolbar__product-count');

              if ($products.length == 0) {
                $productsList.html('<p>No matching results. </p>');
              }

               $productsList.html('');
             
                $productsList.append($products);
              

              $filterCount.html($products.length + ' products');
              
            
              
            },
            complete: function() {
            
            }
          })
          
          
          
        }
        
      //  location.href = newURL;
        
      });
}); 
    
  
    $(document).on('click', '.filter--clear a', function(e) {
      e.preventDefault();
      
      var url = $(this).attr('href');
     //	window.location.href = newURL;

      $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML){

              $('.filter--clear').hide();
              
              var $products = $(responseHTML).find('#product-grid li');
        
              
              
              var $productsList = $('#product-grid');
              var $filterCount = $('.filters-toolbar__product-count');

              if ($products.length == 0) {
                $productsList.html('<p>No matching results. </p>');
              }

               $productsList.html('');
             
                $productsList.append($products);
              

              $filterCount.html($products.length + ' products');
              
            
              
            },
            complete: function() {
            
            }
          })
      
    });
    
  });
  
  $(document).on('click', '.filtershow', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.collection-sidebar').toggleClass('active');
  });
  
})(jQuery);

